import { CreateElement, VNode } from "vue";
import { Vue, Component, Model, Prop } from "vue-property-decorator";
import { busy, db, IRestResult, VIPUser, VIPUserRest } from "@/loader";

let usersLoaded: boolean = false;

@Component
export default class UserSelect extends Vue {
	@Model("input", { default: null })
	public value!: any;

	@Prop({ type: Boolean, default: false })
	public canEdit!: boolean;

	@Prop({ type: Boolean, default: false })
	public multiple!: boolean;

	@Prop({ type: [String, Array], default: null })
	public role!: string | string[] | null;

	@Prop({ type: Array, default: () => [] })
	public include!: VIPUser[];

	@Prop({ type: Array, default: () => [] })
	public exclude!: VIPUser[];

	@Prop({ type: Function, default: (option: VIPUser) => option.id })
	public reduce!: Function;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get users(): VIPUser[] {
		return db.users.list
			.filter(c =>
				(!this.include.length || this.include.includes(c))
				&& !this.exclude.includes(c)
				&& (
					!this.role
					|| (Array.isArray(this.role) && this.role.filter(r => c.roles.includes(r)).length > 0)
					|| (typeof this.role === "string" && c.roles.includes(this.role))
				))
			.sort((a, b) => a.name.localeCompare(b.name));
	}

	public filter(options: VIPUser[], search: string) {
		search = search.toLowerCase().removeDiacritics();
		return options.filter(option => option.toString().includes(search));
	}

	public render(h: CreateElement): VNode {
		let select = h("v-select", {
			class: "form-control",
			attrs: {
				name: "user",
			},
			props: {
				label: "name",
				value: this.value,
				disabled: this.isBusy,
				readonly: !this.canEdit,
				options: this.users,
				reduce: this.reduce,
			},
			on: {
				input: (value: any) => this.$emit("input", value),
			},
		});

		return select;
	}

	public async created() {
		if (!usersLoaded) {
			usersLoaded = true;
			const per_page = 100;
			let result: IRestResult<VIPUser> | null = null;
			let page = 1;
			do {
				result = await VIPUserRest.list({ page, per_page });
				if (result.success && result.total && Math.ceil(result.total / per_page) > page) {
					page++;
				} else  {
					break;
				}
			} while (result.success);
		}
	}
}
